import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    message:{
        marginLeft: '5%',
        marginRight: '5%',
    },
    circularProgress:{
        "&>div":{
            color:"#fff",
            width:"25px !important",
            height:"25px !important",
            marginRight: 7,
        }
    },
    button:{
        margin: 'auto',
        marginLeft: '45%',
        fontSize: '2em'
    },
    appBar: {
        position: 'relative',
        background: '#205690'
      },
      root: {
        flexGrow: 1,
        marginBottom: 40,
      },
      title: {
        marginLeft: theme.spacing(2),
        flex: 1,
      },
    centerTitle: {
        textAlign: 'center',
        // marginTop: '10px',
        marginBottom: '10px',
        backgroundColor:'gainsboro',
    },    
  }));
